/**
 * Re-exports currency utilities from @final-commerce/common.
 * BuilderRender uses the same package as Render for currency enums and conversion.
 */

import {
  CurrencyCode,
  getCurrencyConfig,
  parseAmountToMinorUnits,
  addAmounts,
  subtractAmounts,
} from "@final-commerce/common";

export { CurrencyCode, addAmounts, subtractAmounts };

/**
 * Gets minor units (decimal places) for a currency.
 */
export function getMinorUnitsFromCurrency(currency: string): number {
  return getCurrencyConfig(currency as CurrencyCode).minorUnits;
}

/**
 * Ensures any amount (string or number) is converted to minor units.
 * Handles user input in major units and legacy string format.
 */
export function ensureAmountInMinorUnits(amount: unknown, currency: string): number {
  if (amount === undefined || amount === null) return 0;
  if (typeof amount === "string") {
    const converted = parseAmountToMinorUnits(amount, currency as CurrencyCode);
    return converted !== null ? converted : 0;
  }
  if (typeof amount === "number") {
    const config = getCurrencyConfig(currency as CurrencyCode);
    const multiplier = Math.pow(10, config.minorUnits);
    if (amount % 1 !== 0) {
      return Math.round(amount * multiplier);
    }
    return Math.round(amount);
  }
  return 0;
}
